import React from 'react';
import FieldModal from '../../../components/modals/fieldModal';

class ManageCalendarsModal extends React.Component {
    state = {
        submitting: false,
    };

    render() {
        const { isOpen, toggle, submit, actionType } = this.props; 
        const { submitting } = this.state;

        const isPublish = actionType === 'Publish'; 

        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={isPublish ? 'Publish Calendar' : 'Unpublish Calendar'} 
                    bodyHeaderText={
                        <div>
                            {!submitting
                                ? `Are you sure you want to ${isPublish ? 'publish' : 'unpublish'} this calendar?`
                                : `Calendar ${isPublish ? 'published' : 'unpublished'}.`}
                        </div>
                    }
                    bodyContent={() => {
                        return ''; 
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? `${isPublish ? 'Confirm' : 'Confirm'}` : `${isPublish ? 'Confirming...' : 'Confirming...'}`}
                    actionButton={() => submit()} 
                    actionButtonDisabled={submitting}
                    isDelete={false} 
                />
            </div>
        );
    }
}

export default ManageCalendarsModal;
